var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgJobTrackedLinksFilled = function SvgJobTrackedLinksFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18.593 2.189a1 1 0 0 0-1.682-.393l-2.385 2.52A3.75 3.75 0 0 0 13.5 6.895v2.545l-2.03 2.03a.75.75 0 0 0 1.06 1.061l2.03-2.03h2.546a3.75 3.75 0 0 0 2.577-1.026l2.521-2.385a1 1 0 0 0-.393-1.682l-2.46-.757z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.5 12a8.5 8.5 0 0 1 8.96-8.488.75.75 0 0 0 .08-1.498Q12.27 2 12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10q0-.271-.014-.54a.75.75 0 0 0-1.498.08q.012.228.012.46a8.5 8.5 0 0 1-17 0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.144 7.557a.75.75 0 1 0-.287-1.473A6.015 6.015 0 0 0 12.013 18a6.015 6.015 0 0 0 5.902-4.856.75.75 0 1 0-1.473-.287 4.515 4.515 0 0 1-8.942-.87 4.515 4.515 0 0 1 3.643-4.43"
  })));
};
export default SvgJobTrackedLinksFilled;